import { memo, useCallback } from "react";
import { Avatar } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { map } from "../../../utils/fp";
import { useCharacterStore } from "../../../store/character";
import { getAvatrUrl } from "../../../utils/avatar";
import Create from "../../../components/Character/Create";

interface Props {
  active: any;
  setActive: (active: any) => void;
}

const Nav = ({ active, setActive }: Props) => {
  const { character } = useCharacterStore();

  const onEditSuccess = useCallback(
    (res: any) => {
      setActive(res);
    },
    [setActive]
  );

  return (
    <div className="w-[300px]  h-full overflow-y-auto border-r ">
      <div className="  border-b  p-4  font-bold cursor-pointer">
        <Create key={active.id} setRole={onEditSuccess}>
          <div className="w-full  rounded-xl item-center  justify-center bg-[#f3f3f3] py-4 flex   shadow-[0_1px_7px_0px_rgba(0,0,0,0.06)]   ">
            <div>
              <PlusCircleOutlined className="text-brand-green  text-[16px] mr-1" />
              <span className="text-brand-green"> 新角色</span>
            </div>
          </div>
        </Create>
      </div>
      {map((item: any) => (
        <div
          key={item.id}
          onClick={() => {
            setActive(item);
          }}
          className={`${
            item.id === active.id && "bg-gray-100"
          } flex border-b border-gray-100 px-4  items-center py-4 cursor-pointer`}
        >
          <Avatar
            src={getAvatrUrl(item)}
            shape="square"
            className="mr-1 w-[36px] h-[36px]"
          />

          <div className="flex items-center">
            <div className="">{item?.nickname}</div>
          </div>
        </div>
      ))(character)}
    </div>
  );
};

export default memo(Nav);
